import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import RelatorioInscricaoMunicipaisGeradores from './RelatorioInscricaoMunicipaisGeradores';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';

//Api
import relatorio_api from '../../../api/relatorio_api';
import prefeitura_api from '../../../api/prefeitura_api';
import gerador_api from '../../../api/gerador_api';

function initialStateFiltros() {
    return {
        gerador_selected: null,
        cnpj: "",
        nomeRelatorio: "Relatórios - Inscrição Municipais dos Geradores"
    }
}

export default function InscricaoMunicipaisGeradores() {
    //Variavel utilizada para navegação 
    const navigate = useNavigate();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState([]);

     //Guarda os filtros obrigatorios
     const campos = [
        objCampo({ name: "cnpj", required: true })
    ]

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {
        const _errors = validarCampos(filtros, campos);
        
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        setLoading(true);
        relatorio_api.InscricaoMunicipaisGeradores(filtros).then(response => {
            setFiltros({...filtros, gerador_selected: response?.data[0]?.nomeFantasia});
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (dadosRelatorio.length > 0) {
        return <RelatorioInscricaoMunicipaisGeradores
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio([])}
            filtros={filtros}
        />
    }

    return <MainCard btnVoltarInTop={() => navigate(-1)}>
        {loading && <Loading />}
        <h4>Relatório de inscrição municipais</h4>
        <Row>
            <Col sm="12" md="6" lg="4">
                <TextField
                    name="cnpj"
                    label={"CNPJ"}
                    type={"text"}
                    mask={mascaras.cnpjMask}
                    maxLength={18}
                    value={filtros.cnpj}
                    onChange={onChangeFiltros}
                    invalid={!!errors.cnpj}
                />
                <PrintValidate field={"geradorId"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                <Button
                    className='w-100 fw-bold'
                    color='info text-light'
                    onClick={carregarRelatorio}
                >
                    Gerar Relatório
                </Button>
            </Col>
        </Row>
    </MainCard>;
}